var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.0513,16 C20.5733,16 21.0003,16.427 21.0003,16.949 L21.0003,16.949 L21.0003,17.051 C21.0003,17.573 20.5733,18 20.0513,18 L20.0513,18 L3.9483,18 C3.4263,18 3.0003,17.573 3.0003,17.051 L3.0003,17.051 L3.0003,16.949 C3.0003,16.427 3.4263,16 3.9483,16 L3.9483,16 Z M20.0513,11 C20.5733,11 21.0003,11.427 21.0003,11.949 L21.0003,11.949 L21.0003,12.051 C21.0003,12.573 20.5733,13 20.0513,13 L20.0513,13 L3.9483,13 C3.4263,13 3.0003,12.573 3.0003,12.051 L3.0003,12.051 L3.0003,11.949 C3.0003,11.427 3.4263,11 3.9483,11 L3.9483,11 Z M20.0513,6 C20.5733,6 21.0003,6.427 21.0003,6.949 L21.0003,6.949 L21.0003,7.051 C21.0003,7.573 20.5733,8 20.0513,8 L20.0513,8 L3.9483,8 C3.4263,8 3.0003,7.573 3.0003,7.051 L3.0003,7.051 L3.0003,6.949 C3.0003,6.427 3.4263,6 3.9483,6 L3.9483,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0D1C2E",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.429683d03ba8df328a3e245d938999cb.svg";
export { ForwardRef as ReactComponent };